import React from 'react';
import { checkCondition } from '../formBuilder/utility/filterSchema';
import investmentCriteriaDefaults from '../../constants/investmentCriteria';
import { isValue } from '../../utility/isValue';
import classNames from 'classnames';

import calculateField from '../formBuilder/utility/calculateFields';

export default function InvestmentCriteriaOverview({ schema, data, disabled }) {
  if (!schema || !data) return null;

  const filteredSchema = schema?.filter((field) => {
    if (!field.condition) return true;
    if (!Array.isArray(field.condition)) {
      const value = data[field.condition.field];
      if (
        !isValue(value) &&
        investmentCriteriaDefaults[field.condition.field]
      ) {
        return true;
      }
    } else {
      return field.condition.every((option) => {
        const value = data[option.field];

        if (!isValue(value) && investmentCriteriaDefaults[option.field]) {
          return true;
        }
      });
    }
    return checkCondition(field.condition, data);
  });

  const results = filteredSchema?.map((field) => getResult(field, data)) || [];
  const sortedResults = [...results].sort((a, b) => b?.value - a?.value);

  const percentagePassed =
    disabled || !results.length
      ? '-'
      : `${
          Math.round(
            (results.filter((result) => result?.value === 1).length /
              results.length) *
              10000
          ) / 100
        }%`;

  if (!filteredSchema || !filteredSchema.length) return null;

  return (
    <div className="rounded-lg relative bg-white px-6 py-4 flex items-center justify-center gap-4">
      <div className="grid grid-cols-4 gap-1 flex-shrink">
        {sortedResults.map((result, index) => (
          <div
            key={index}
            className={classNames(
              'rounded-sm w-[10px] h-[10px]',
              disabled
                ? 'bg-neutral-100'
                : result?.value === 1
                ? 'bg-primary-500'
                : 'bg-primary-500 opacity-25'
            )}
          ></div>
        ))}
      </div>
      <div className="flex flex-col items-start">
        <h3 className="text-md text-neutral-600">Investment Criteria</h3>
        <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
          <span className={disabled ? 'text-neutral-500' : 'text-neutral-900'}>
            {percentagePassed}
          </span>
        </p>
      </div>
    </div>
  );
}

export const getResult = (field, data) => {
  try {
    return calculateField(field, data, 'object');
  } catch (error) {
    console.error(error);
    return { value: 2, message: 'Error' };
  }
};
